module.exports = __webpack_public_path__ + "static/images/styles/images/leaderboards/battle_mode_6.491987dc.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/leaderboards/battle_mode_6.png
// module id = 3655
// module chunks = 11